/** UI mirrors server policy; authorization remains server-side. */
export const providerFeatures = $state({ realDebrid: false, torbox: false, premiumize: true });
let generation = 0;
export async function loadProviderFeatures(): Promise<void> {
  const epoch=++generation;
  try {
    const r=await fetch('/api/providers',{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(8000)});
    if(!r.ok)return;
    const data=await r.json() as {enabled?:unknown};
    if(epoch!==generation || !Array.isArray(data.enabled))return;
    providerFeatures.realDebrid=data.enabled.includes('real-debrid');
    providerFeatures.torbox=data.enabled.includes('torbox');
    providerFeatures.premiumize=data.enabled.includes('premiumize');
  } catch { /* default-off optional providers remain unavailable */ }
}
